var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from "react";
import classNames from "classnames";
import IconContainer from "../IconContainer";
const LoadingIcon = (_a) => {
    var { className, size, title } = _a, props = __rest(_a, ["className", "size", "title"]);
    return (React.createElement(IconContainer, Object.assign({ className: classNames("gerudo-icon-loading", size, className) }, props),
        React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", focusable: "false", "data-icon": "loading", width: "1em", height: "1em", "aria-hidden": "true" },
            React.createElement("title", null, title),
            React.createElement("g", { fill: "none" },
                React.createElement("circle", { cx: "12", cy: "12", r: "11" }),
                React.createElement("path", { d: "M1 12C1 5.9 5.9 1 12 1", stroke: "currentColor", strokeWidth: "2", strokeLinecap: "round", strokeMiterlimit: "10" })))));
};
export { LoadingIcon };
export default LoadingIcon;
//# sourceMappingURL=Loading.js.map